/* Saturo LP Alternative v2 — reveal on scroll + bar chart trigger */
if (!window.__lp2Init) {
  window.__lp2Init = true;
  (function () {
    function init() {
      var roots = document.querySelectorAll('.lp2');
      if (!roots.length) return;
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.lp2-rev').forEach(function (e) { e.classList.add('in'); });
        roots.forEach(function (r) { r.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.lp2-rev').forEach(function (e) { io.observe(e); });

      // bar chart: add is-in to the .lp2 root when the compare panel appears
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            var root = e.target.closest('.lp2');
            if (root) root.classList.add('is-in');
            io2.unobserve(e.target);
          }
        });
      }, { threshold: 0.3 });
      document.querySelectorAll('.lp2-duel').forEach(function (e) { io2.observe(e); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
}
